<dialog
  #dialog
  class="overlay"
  tabindex="-1"
  closedby="none"
  aria-labelledby="loading-overlay-status"
  (cancel)="onCancel($event)"
  (close)="onClose()"
>
  <div class="loader" aria-hidden="true">
    <span class="bar"></span>
    <span class="bar"></span>
    <span class="bar"></span>
  </div>
  <p id="loading-overlay-status" class="visually-hidden" role="status">Cargando…</p>
</dialog>
